// extracted by mini-css-extract-plugin
export var productImage = "_p5-1";
export var viewLink = "_p5-2";
export var wishlistItem = "_p5-0";